import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import MainLayout from './components/Layout/MainLayout'
import './i18n.ts'
import LoadingPage from './pages/LoadingPage'
import loadBNetCoreComponents from './requests/loadBNetCoreComponents.ts'
import { getCurrentLanguageFromUrl, supportedLangs } from './utils/language'
import applyLocalDevInterceptor from './utils/localDevInterceptor'

const bnetBwaCoreUrl = import.meta.env.VITE_BNET_BWA_CORE_URL || ''

const root = createRoot(document.getElementById('root')!)

// Apply local development interceptor to include an 'x-verified-vpc-payload' payload in fetch requests. This is required
// for development against a locally running backend in order for the calls to be considered validated.
applyLocalDevInterceptor()

// Render the initial loading page before bethesda.net header and footer are initialized
root.render(
  <StrictMode>
    <MainLayout>
      <LoadingPage />
    </MainLayout>
  </StrictMode>,
)

// Initialize bethesda.net header before rendering the React app
loadBNetCoreComponents(window, bnetBwaCoreUrl)
  .then(async (initBethnet) => {
    const bethnet = await initBethnet({
      unGated: true,
      coreModel: `${bnetBwaCoreUrl}/data/core`,
      localization: { langs: supportedLangs, language: getCurrentLanguageFromUrl() },
    })

    if (!bethnet) {
      // TODO: Handle this. Should we display the page still?
      console.error('Error loading bnet core components')
    }
  })
  .then(() => {
    root.render(
      <StrictMode>
        <MainLayout>
          <App />
        </MainLayout>
      </StrictMode>,
    )
  })
